import { atom } from 'recoil';

export const faqCurrentPage = atom({
  key: 'faqCurrentPage',
  default: 1,
});
